"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WhiteBackdrop = exports.TitleMessage = exports.LoadingTitle = exports.LoadingIcon = exports.ContentWrapper = void 0;
var _mui = require("@ori-ui/mui");
const WhiteBackdrop = exports.WhiteBackdrop = (0, _mui.styled)(_mui.Backdrop)((param)=>{
    let { theme } = param;
    return {
        background: (0, _mui.alpha)(theme.palette.common.white, 0.9),
        zIndex: theme.zIndex.drawer + 1
    };
});
const ContentWrapper = exports.ContentWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        position: 'absolute',
        top: 'calc(50% - 50px)',
        left: 0,
        transform: 'translateY(-50%)',
        textAlign: 'center',
        width: "calc(100% - ".concat(theme.spacing(6), ")"),
        padding: theme.spacing(0, 3),
        zIndex: theme.zIndex.drawer + 1,
        [theme.breakpoints.up('sm')]: {
            width: "calc(100% - ".concat(theme.spacing(12), ")"),
            padding: theme.spacing(0, 6)
        }
    };
});
const LoadingIcon = exports.LoadingIcon = (0, _mui.styled)(_mui.CircularProgress)({
    width: 80,
    height: 80
});
const LoadingTitle = exports.LoadingTitle = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(6, 0, 3),
        minHeight: 54,
        width: '100%',
        position: 'relative',
        [theme.breakpoints.up('sm')]: {
            minHeight: 62
        }
    };
});
const TitleMessage = exports.TitleMessage = (0, _mui.styled)(_mui.Typography)({
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%'
});
